import React from "react";
import { FaBolt, FaDesktop, FaDoorOpen } from "react-icons/fa";

const LabAccessSection = () => {
  return (
    <section className="home-section">
      <div className="home-container">
        <div className="home-card-strong relative overflow-hidden p-8 sm:p-10">
          <div
            className="absolute -right-10 -top-10 h-36 w-36 rounded-full"
            style={{ background: "color-mix(in srgb, var(--brand-soft) 70%, transparent)" }}
          />

          <span className="section-kicker">Facility Access</span>
          <h2 className="home-title mt-4 text-2xl font-bold sm:text-4xl">
            ACM Lab privileges for <span className="home-accent-gradient">top performers</span>
          </h2>
          <p className="mt-4 max-w-3xl text-sm sm:text-base home-muted">
            Top performers in the GUB Competitive Programming Arena receive access to ACM Lab (Room B-109) for focused practice, team preparation, and advanced training.
          </p>

          <div className="mt-6 grid gap-3 sm:grid-cols-3">
            <div className="home-card p-4 text-sm"><FaDesktop className="mr-2 inline home-accent" /> High-performance workstations</div>
            <div className="home-card p-4 text-sm"><FaDoorOpen className="mr-2 inline home-accent" /> Dedicated practice environment</div>
            <div className="home-card p-4 text-sm"><FaBolt className="mr-2 inline home-accent" /> High-focus preparation zone</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LabAccessSection;
